import KaistoreHawkHelper from 'kaistore-hawk-helper/lib';

class KaistoreAppListHelper {
  constructor({
    deviceInfos,
    simInfo,
    IMEI = '0123456789',
    serverTimeOffset,
    useCustomConnectionType = false
  }) {
    this._deviceIMEI = IMEI;
    this._deviceInfos = deviceInfos;
    this._simInfo = simInfo;
    this._requester = KaistoreHawkHelper.getRequester({
      serverTimeOffset,
      deviceInfos,
      useCustomConnectionType
    });
    this._apiName = 'apps';
    this._apiURI = deviceInfos.get('apps.serviceCenterUrl');
  }

  // [name] => server:update or server:error
  _emit(name, details, msg = '') {
    const event = new CustomEvent(name, {
      detail: details
    });
    window.dispatchEvent(event);

    if (name === 'server:error') {
      console.error(msg);
    }
  }

  // Only support in v3.0.
  // apiURI should be "https://example.com" or "https://example.com/v3.0"
  _isBookmarkSupported() {
    const URIArray = this._apiURI.split('/');
    const apiVersion = URIArray[3];

    if (apiVersion && apiVersion.indexOf('v3.0') >= 0) {
      return true;
    }
    return false;
  }

  // Obtain the params for fetch app list.
  _getAppListParams() {
    const bookmarkSupported = this._isBookmarkSupported();
    const defaultServiceId = this._deviceInfos.get('ril.data.defaultServiceId');
    let params = {
      bookmark: bookmarkSupported,
      defaultServiceId: defaultServiceId,
      imei: this._deviceIMEI
    };
    let deviceParams = {};

    this._deviceInfos.forEach((value, key) => {
      if (key.indexOf('deviceinfo') >= 0) {
        const keyInfo = key.split('.');
        const valueWithoutSpace = value.replace(/ /g, '_');

        deviceParams[keyInfo[keyInfo.length - 1]] = valueWithoutSpace;
      }
    });

    return Object.assign(params, this._simInfo, deviceParams);
  }

  _hasPaidApp(appAry) {
    return appAry.some(app => app.paid === true);
  }

  fetch() {
    return new Promise((resolve, reject) => {
      const params = this._getAppListParams();

      this._requester
        .send({
          url: KaistoreHawkHelper.generateURL({
            apiName: this._apiName,
            deviceInfos: this._deviceInfos,
            params
          }),
          method: 'GET'
        })
        .then(
          result => {
            resolve(JSON.parse(result));
          },
          error => {
            reject(error);
          }
        );
    });
  }

  fetchAppList(isPaymentAvailable = true) {
    return new Promise((resolve, reject) => {
      this.fetch().then((result) => {
        const apps = result.apps;
        if (apps.length === 0){
          reject({ errorMsgId: 'no-app-available' });
          return;
        }
        const hasPaidApp = this._hasPaidApp(apps);
        if (hasPaidApp && (isPaymentAvailable === false)) {
          result.apps = apps.filter(
            app => app.installed === true || app.paid === false
          );
        }
        result.hasPaidApp = hasPaidApp;
        resolve(result);
      }).catch((error) => {
        console.error('error in fetchAppList', error);
        reject({ errorMsgId: 'connection-error'});
      })
    })
  }
}

export default KaistoreAppListHelper;



/** WEBPACK FOOTER **
 ** ./~/kaistore-applist-helper/lib/index.js
 **/